<style scoped></style>

<template>
  <SafeVerifyModal
    v-model="modalVis.mentionMoneyVerifyModal"
    :smstype="16"
    @on-ok="confirmHandle"
  ></SafeVerifyModal>
</template>

<script>
import { ajaxPost_MentionMoney } from '@/api/assets'
// import SafeVerifyModal from '@/views/personal/Modal/SafeVerifyModal'
import { ajax_setFundPass } from '@/api/personal'
import { ajaxTry, ajaxDataShrink, ajaxAlert, updateUserInfo } from '@/utils'

export default {
  name: 'MentionMoneyVerifyModal',
  props: {
    mentionMoneyAjaxParam: {
      type: Object,
      default: () => {}
    }
  },
  inject: {
    modalVis: 'modalVis'
  },
  data() {
    return {
      password: ''
    }
  },
  components: {
    SafeVerifyModal
  },
  async mounted() {
    this.password = await this.$receiver(
      'dataOnce-MentionMoney-MentionMoneyVerifyModal'
    )
  },
  methods: {
    async confirmHandle(code) {
      // debugger
      let { email, phone, google } = code
      let ajaxParam = Object.assign(this.mentionMoneyAjaxParam, {
        smsCode: phone,
        googleCode: google,
        emailCode: email
      })
      this.$sender('modify-Public-SafeVerifyModal', 'btnLoading.confirm', true)
      let [flag, res] = await ajaxTry(ajaxPost_MentionMoney(ajaxParam)).then(
        ajaxDataShrink
      )
      this.$sender('modify-Public-SafeVerifyModal', 'btnLoading.confirm', false)
      if (flag) {
        this.modalVis.fundPassVerify = false
        this.$Modal.success({
          title: res.message,
          onOk: () => {
            this.$router.push('/myassets')
          }
        })
      } else {
        this.$Modal.error({
          title: res.message
        })
      }
    }
  }
}
</script>
